<template>
    <div id="loginbody" class="text-center">
<form v-on:submit.prevent="signUp" class="form-signin">
    <img class="mb-4" src="./assets/logo.png" alt="" width="144" height="144">

    <h5>Let's Create a new Lyfe Planner account</h5>
    <label for="inputEmail" class="sr-only">Email address</label>
    <input type="email" id="inputEmail" class="form-control"  v-model="email" placeholder="Email" required autofocus>
    <label for="inputPassword" class="sr-only">Password</label>
    <input type="password" id="inputPassword" class="form-control" v-model="password" placeholder="Password" required>
    <button class="btn btn-lg btn-primary btn-block" type="submit">Sign Up</button>
    <p>or go back to <router-link to="/login">login</router-link>.</p>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');
    export default {
        name: 'signUp',
        data(){
            return {
                email: '',
                password: ''
            };
        },
        methods: {
            signUp: function(){
                firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
                    (user) => {
                        this.$router.replace('home')
                    },
                    (err) => {
                        alert('Oops! ' + err.message)
                    }
                )
            }
        }
    }
</script>

<style scoped>
#loginbody {
  height: 100%;
}

#loginbody {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
  
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
